/**
 * @generated SignedSource<<38a265b10d03401ece235d268b8b60e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleaseImagesGrid_artist$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useArtistThumbnailUrl_artist">;
  readonly " $fragmentType": "ReleaseImagesGrid_artist";
};
export type ReleaseImagesGrid_artist$key = {
  readonly " $data"?: ReleaseImagesGrid_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReleaseImagesGrid_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReleaseImagesGrid_artist",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useArtistThumbnailUrl_artist"
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "4a92cc5ed2f280d2ab615d3e1fbbeb18";

export default node;
